import {createRouter, createWebHistory} from 'vue-router';
import HomeView from '../views/HomeView';
import AnalyzerView from '../views/AnalyzerView';
import FinderView from '../views/FinderView';
import ScanView from '../views/ScanView';

const router = createRouter({
	history: createWebHistory('/'),
	routes: [
		{path: '/', name: 'home', component: HomeView},
		{path: '/analyzer', name: 'analyzer', component: AnalyzerView},
		{path: '/finder', name: 'finder', component: FinderView},
		{path: '/scanner', name: 'scanner', component: ScanView}
	]
});

export default router;
